import React, { FunctionComponent, Fragment, useEffect, Suspense, useState, useCallback } from "react";

// bissl hacky, oba des isch die beste methode um a onModelLoaded Funktion zu implementieren

interface IThreeLoadingSuspenseProps {
  onModelLoaded: () => void;
}

interface IThreeFallbackPrpos {
  onModelLoaded: () => void;
  onInitialRender: () => void;
}

const Fallback: FunctionComponent<IThreeFallbackPrpos> = (props) => {
  const { onModelLoaded, onInitialRender } = props;

  useEffect(() => {
    onInitialRender();
    return () => {
      onModelLoaded();
    };
  }, [onModelLoaded, onInitialRender]);
  return <Fragment />;
};

export const ThreeLoadingSuspense: FunctionComponent<IThreeLoadingSuspenseProps> = (props) => {
  const { onModelLoaded } = props;
  const [didFallbackRender, setDidFallbackRender] = useState<boolean>(false);
  const [initialRenderDone, setInitialRenderDone] = useState<boolean>(false);

  useEffect(() => {
    if (!didFallbackRender && initialRenderDone) {
      onModelLoaded();
    }
  }, [didFallbackRender, initialRenderDone, onModelLoaded]);

  useEffect(() => setInitialRenderDone(true), [setInitialRenderDone]);

  const onInitialFallbackRender = useCallback(() => setDidFallbackRender(true), [setDidFallbackRender]);

  return (
    <Suspense
      fallback={<Fallback {...props} onModelLoaded={onModelLoaded} onInitialRender={onInitialFallbackRender} />}
    >
      {props.children}
    </Suspense>
  );
};
